'use client';
import { AxiosError } from 'axios';
import { useState } from 'react';

import { useFlowContext } from '@/components/flow/hooks/useFlowContext';
import { Checkbox, CheckboxGroup } from '@/components/ui/checkboxGroup';
import { FlowContainer } from '@/components/ui/container';
import { PageHeader } from '@/components/ui/pageHeader';
import { SectionHeading } from '@/components/ui/sectionHeading';
import { useSessionExpired } from '@/hooks/useSessionExpired';
import { storeResponses } from '@/services/visitsService/client';
import { useVisitContext } from '@/services/visitsService/hooks/useVisitContext';
import { type VisitQuestion } from '@/services/visitsService/types';

const ClientContainer = ({
  question,
  config,
}: {
  question: VisitQuestion;
  config: any;
}) => {
  const { visit } = useVisitContext();
  const { brand } = useFlowContext();
  const { handleIfSessionExpired } = useSessionExpired(brand);
  const [selected, setSelected] = useState<string[]>(
    (visit?.responses.find((r) => r.question.id === question.id)?.value as
      | string[]
      | []) || [],
  );

  if (!visit) {
    return null;
  }

  const submit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      await storeResponses({
        visit,
        context: 'skincare-goals',
        responses: [{ questionId: question.id, response: selected }],
      });
    } catch (error) {
      const status =
        error instanceof AxiosError ? error.response?.status : undefined;
      handleIfSessionExpired(status);
    }
  };

  return (
    <form method="post" onSubmit={submit}>
      <div>
        <PageHeader
          title={config.title}
          pill="Step 1"
          variant="cover"
          imgSrc="https://images.ctfassets.net/8pzh4g8cs30t/5vEeYez8APYk5WdT4FYAwK/63433c41ffbe8cea4f4c5a15ce035d43/image.png"
        />
        <FlowContainer>
          {config.categories.map((category: any) => (
            <div key={category.title}>
              <SectionHeading
                title={category.title}
                description={category.description}
              />
              <CheckboxGroup className="cur-mt-4">
                {category.choices.map((choice: any) => (
                  <Checkbox
                    value={choice.value}
                    checked={selected.includes(choice.value)}
                    image={choice.image}
                    onChange={(checked) =>
                      checked
                        ? setSelected([...selected, choice.value])
                        : setSelected(
                            selected.filter((value) => value !== choice.value),
                          )
                    }
                    key={choice.value}
                  >
                    {choice.label}
                  </Checkbox>
                ))}
              </CheckboxGroup>
            </div>
          ))}
        </FlowContainer>
        {/* TODO: Replace with real navigation */}
        <button type="submit">Next</button>
      </div>
    </form>
  );
};

export { ClientContainer };
